import React from "react";
import BarcodeReader from "../../../../stories/_setting/BarcodeReaders/BarcodeReader";
import FormStart from "../../../form/barcodereader/FormStart";
import '../../../../css/overbox/BarcodeReaderInformation.css';

const NewObject = props => {
    const {handleIndex} = props;

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className="overbox start">
                    <FormStart object={new BarcodeReader()} handleIndex={handleIndex} />
                </div>
            </div>
        </div>
    )
}

export default NewObject;
